module.exports = __webpack_public_path__ + "3ad42e93906af4ef03cc52095c319aca.MP3";